const initialState = {}

export default function payment_details(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_PAYMENT_DETAILS':
      return Object.assign({}, action.change);

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/event_render/reducers/payment_details.js